export var ISubscription;
(function (ISubscription) {
    ISubscription["FREEMIUM"] = "freemium";
    ISubscription["PREMIUM"] = "premium";
    ISubscription["PLATINUM"] = "platinum";
})(ISubscription || (ISubscription = {}));
